import { useEffect } from 'react';

import { OnboardingProgressStep, useProgress } from '@/context/progress';
import ForbiddenJurisdiction from '@/features/forbidden-jurisdiction/components/forbidden-jurisdiction';
import PersonalInformationLayout from '@/features/onboarding/personal-information/layout';

const PersonalInformationForbiddenJurisdictionPage = () => {
  const { setCurrentStep } = useProgress();

  useEffect(() => {
    return setCurrentStep(OnboardingProgressStep.PERSONAL_INFORMATION, 1);
  }, [setCurrentStep]);

  return (
    <PersonalInformationLayout className="-md:justify-center space-y-8" size="sm">
      <ForbiddenJurisdiction />
    </PersonalInformationLayout>
  );
};
PersonalInformationForbiddenJurisdictionPage.displayName = 'PersonalInformationForbiddenPage';

export default PersonalInformationForbiddenJurisdictionPage;
